import { render, staticRenderFns } from "./CustomerImageUpload.vue?vue&type=template&id=756b7758"
import script from "./CustomerImageUpload.vue?vue&type=script&lang=js"
export * from "./CustomerImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports